var _defs, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack388({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 8,
    rx: 7,
    ry: 7.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.11,8.72l.62.19A2.72,2.72,0,0,1,7,10.35a1.8,1.8,0,0,1-1.26.48,1.94,1.94,0,0,1-1.12-.32,2.34,2.34,0,0,1-.76-1,4.36,4.36,0,0,1-.29-1.66,4,4,0,0,1,.29-1.6,2.42,2.42,0,0,1,.8-1A2,2,0,0,1,5.8,4.9,1.75,1.75,0,0,1,7,5.32a2.33,2.33,0,0,1,.68,1.24L7,6.74C6.83,6,6.42,5.55,5.79,5.55A1.39,1.39,0,0,0,5,5.79a1.64,1.64,0,0,0-.55.75,3.58,3.58,0,0,0-.2,1.28,3.13,3.13,0,0,0,.41,1.77,1.3,1.3,0,0,0,1.1.59,1.21,1.21,0,0,0,.88-.36A2,2,0,0,0,7.11,8.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.5,10.73V5h2.09a2.16,2.16,0,0,1,1,.16,1.25,1.25,0,0,1,.51.53,1.86,1.86,0,0,1,.2.87,1.46,1.46,0,0,1-1.32,1.56,1.51,1.51,0,0,1,.4.32,4.19,4.19,0,0,1,.48.73l.82,1.56h-.78l-.62-1.19a8.45,8.45,0,0,0-.55-.94,1.17,1.17,0,0,0-.36-.33,1.1,1.1,0,0,0-.49-.09H9.12v2.55Zm.62-3.2h1.34a1.61,1.61,0,0,0,.66-.11.72.72,0,0,0,.36-.33,1,1,0,0,0,.14-.53.91.91,0,0,0-.26-.68,1.06,1.06,0,0,0-.75-.25H9.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack388);
export default __webpack_public_path__ + "static/media/Symbol_pack_388.df86602cc920240e6c41110094bc3513.svg";
export { ForwardRef as ReactComponent };